import { Form } from "antd";

import { SeverityFieldNames } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/constants";
import { getSelectedComponent } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/gridUtils";

import { useSeverityGridFromInterventionAsset } from "./useSeverityGridFromInterventionAsset";

const { useFormInstance, useWatch } = Form;

export const useMaterialsFromSeverityGrid = () => {
  const form = useFormInstance();
  const selection = useWatch(SeverityFieldNames.component, form);
  const { isLoading, severityGrid, isGridDefinedForAsset } =
    useSeverityGridFromInterventionAsset();
  const component = getSelectedComponent({
    selection,
    severityGrid,
  });
  const gridMaterials = component?.materials ?? [];

  return {
    isLoadingGridMaterials: isLoading,
    isGridDefinedForAsset,
    gridMaterials,
    hasCustomComponent: selection && !component,
  };
};
